<template>
  <div class="matching-pdf-container">
    <div v-if="matchingQuestions.length" class="mb-2">
      <div class="font-weight-medium mb-1" style="font-size: 14px; font-weight: bold">Danh sách câu hỏi:</div>

      <div style="display: block; width: 100%; padding-left: 8px">
        <div
          v-for="(qItem, idx) in matchingQuestions"
          :key="qItem.id || idx"
          style="display: block; margin-bottom: 10px"
        >
          <span style="font-weight: bold; margin-right: 6px"> {{ qItem.index + 1 }}. </span>

          <div style="display: inline-block; vertical-align: top; width: calc(100% - 40px)">
            <div style="display: inline-block" v-html="formatInlineHtml(qItem.html)"></div>

            <template v-if="!isQuestionPaper">
              <span class="ml-2" style="display: inline-flex; align-items: center">
                <span
                  :style="{
                    color: submission.isStudentWork
                      ? '#000'
                      : getChildResult(qItem.id).isCorrect
                      ? '#4bca81'
                      : '#d4504c',
                    fontWeight: 'bold',
                    fontSize: '14px',
                  }"
                >
                  [{{ getChildResult(qItem.id).studentLabel }}]
                  <!-- Chỉ hiện icon nếu không phải bài làm HS -->
                  <span
                    v-if="!submission.isStudentWork"
                    style="margin-left: 3px; font-size: 13px"
                    v-html="getChildResult(qItem.id).isCorrect ? '&#10003;' : '&#x2715;'"
                  >
                  </span>
                </span>
              </span>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div v-if="optionsPool.length" class="mb-2 mt-2">
      <div class="font-weight-medium mb-1" style="font-size: 14px; font-weight: bold">Danh sách lựa chọn:</div>

      <div style="display: block; width: 100%; padding-left: 8px">
        <div
          v-for="opt in optionsPool"
          :key="opt.key"
          style="display: inline-block; margin-right: 30px; margin-bottom: 5px"
        >
          <span style="margin-right: 6px">{{ opt.label }}.</span>

          <div style="display: inline-block" v-html="formatInlineHtml(opt.value)"></div>
        </div>
      </div>

      <v-divider class="my-2" style="opacity: 0.3" v-if="!isQuestionPaper" />
    </div>
  </div>
</template>

<script>
import get from 'lodash-es/get'
import {mapGetters} from 'vuex'

export default {
  props: {
    question: Object,
    isQuestionPaper: Boolean,
    submission: Object,
    answers: [Object, Array],
  },

  computed: {
    ...mapGetters({
      allQuestions: 'pdfRender/getQuestions',
    }),

    parentGroup() {
      if (this.question.type.includes('group')) return this.question
      const questionsToSearch = this.allQuestions || []
      return questionsToSearch.find(
        q =>
          q.questions &&
          q.questions.some(childId => {
            const id = typeof childId === 'object' ? childId.id : childId
            return id === this.question.id
          })
      )
    },

    matchingQuestions() {
      const group = this.parentGroup || (this.question.questions ? this.question : null)
      if (!group || !group.questions) return []

      return group.questions
        .map(child => {
          if (typeof child === 'object' && child.html) return child
          const childId = typeof child === 'object' ? child.id : child
          return this.allQuestions.find(q => q.id === childId) || {html: ''}
        })
        .filter(q => q.html)
    },

    optionsPool() {
      const poolSource = this.parentGroup?.answers || this.question.answers
      if (!poolSource) return []

      const answers = Array.isArray(poolSource) ? poolSource : Object.values(poolSource)
      return answers
        .map(a => ({
          key: a.key,
          label: a.label,
          value: a.value,
        }))
        .sort((a, b) => (a.label || '').localeCompare(b.label || ''))
    },
  },

  methods: {
    formatInlineHtml(html) {
      if (!html) return ''

      return html
        .replace(/<p/g, '<span style="display:inline;margin:0;padding:0;"')
        .replace(/<\/p>/g, '</span>')
        .replace(/<div/g, '<span style="display:inline;margin:0;padding:0;"')
        .replace(/<\/div>/g, '</span>')
    },

    extractStudentKeys(answerData) {
      if (Array.isArray(answerData.answerIds)) {
        return answerData.answerIds
      }

      if (answerData.answerId) {
        return [answerData.answerId]
      }

      if (answerData.answer) {
        return [answerData.answer]
      }

      return []
    },

    findLabelByKey(key) {
      let pool = Array.isArray(this.question.answers)
        ? this.question.answers
        : Object.values(this.question.answers || {})

      let found = pool.find(item => item.key === key)

      if (found) return found.label

      pool = Array.isArray(this.parentGroup?.answers)
        ? this.parentGroup.answers
        : Object.values(this.parentGroup?.answers || {})

      found = pool.find(item => item.key === key)

      if (found) return found.label

      for (const q of this.allQuestions || []) {
        const answers = Array.isArray(q.answers) ? q.answers : Object.values(q.answers || {})

        found = answers.find(item => item.key === key)

        if (found) return found.label
      }

      return null
    },

    getChildResult(childId) {
      const answerData = get(this.submission, `answers.${childId}`, {})
      const studentKey = answerData.answer || answerData.answerId
      const foundStudent = this.optionsPool.find(a => a.key === studentKey)

      return {
        isCorrect: answerData.isCorrect || false,
        studentLabel: foundStudent ? foundStudent.label : studentKey ? '?' : '___',
      }
    },
  },
}
</script>
